<template>
  <v-box :scrollable="true" :auto-size="stretch">
    <b-container :fluid="true" class="w-100">
      <b-row no-gutters class="pt-5 w-100">
        <b-col >
        </b-col>

        <b-col cols="auto">
          <b-spinner variant="secondary" label="Loading..."></b-spinner>
        </b-col>

        <b-col >
        </b-col>
      </b-row>
    </b-container>
  </v-box>
</template>

<script>
import VBox from "@/components/VBox";
export default {
  name: "Loading",
  components: {VBox},
  props:{
    stretch:{default: true}
  }
}
</script>

<style scoped>

</style>